import apiClient from '../index';

export const eventApi = {
  // Register new event
  registerEvent: (data) => apiClient.post('/register-event', data),

  // Request OTP for registration
  requestOtp: (number) => apiClient.post('/events/registration/request-otp', { number }),

  // Verify OTP
  verifyOtp: (data) => apiClient.post('/events/registration/verify-otp', data),

  // Get event by ID or UID
  getEvent: (params = {}) => apiClient.get('/events/get-event', { params }),

  // Get all events for current user
  getUserEvents: () => apiClient.get('/user-events'),

  // Set default event for current user
  setDefaultEvent: (id) => apiClient.post('/set-default-event', { id, event_id: id }),

  // Get minimal event list
  getMinimalEvents: () => apiClient.get('/events/list-minimal'),

  // Get event by ID (Public)
  getEventById: (id) => apiClient.get(`/events/get-event/${id}`),

  // Public event registration
  publicRegisterEvent: (data) => apiClient.post('/events/register', data),

  // Get public events (paginated)
  getPublicEvents: async (page = 1) => {
    try {
      const response = await apiClient.get(`/events/public-list?page=${page}`);
      const payload = response?.data;
      const eventsArray = payload?.data;

      if (Array.isArray(eventsArray)) {
        return {
          events: eventsArray.map(event => ({
            id: event.id,
            event_title: event.event_title,
            event_description: event.event_description,
            event_type: event.event_type,
            event_date: event.event_date,
            // wallpaper is an object {lg_photo, md_photo, sm_photo}, not an array
            wallpaper: event.wallpaper || null,
          })),
          currentPage: payload.current_page || 1,
          totalPages: payload.total_pages || 1,
          totalRecords: payload.total_records || 0,
        };
      }
      return { events: [], currentPage: 1, totalPages: 1, totalRecords: 0 };
    } catch (error) {
      console.error('Could not fetch events:', error);
      return { events: [], currentPage: 1, totalPages: 1, totalRecords: 0 };
    }
  },

  // Get event statistics
  getEventStats: () => apiClient.get('/event-stats'),
  getEventStatsById: (id) => apiClient.get(`/event-stats/${id}`),

  // Get dynamic event types list
  getEventTypes: () => apiClient.get('/events/event-types'),

  // Get event summary
  getEventSummary: () => apiClient.get('/event-summary'),

  // Get current event settings
  getEventSettings: () => apiClient.get('/event/get-settings'),

  // Get custom templates
  getCustomTemplates: () => apiClient.get('/event/get-customtemplates'),

  // Update event settings
  updateEventSettings: (data) => apiClient.put('/event/event-settings', data),

  // Update event settings by UID
  updateEventSettingsByUid: (uid, data) => apiClient.put(`/event/update-settings/${uid}`, data),

  // Update custom templates
  updateCustomTemplates: (data) => apiClient.put('/event/update-custom-templates', data),

  // Update event details
  updateEvent: (id, data) => apiClient.put(`/events/${id}`, data),

  // Update auto-send settings
  updateAutoSend: (data) => apiClient.put('/event/auto-send', data),

  // Update price settings
  updatePriceSettings: (id, data) => apiClient.put(`/event/price-settings/${id}`, data),

  // Update invitation message
  updateInvitationMessage: (id, data) => apiClient.put(`/events/${id}/invitation`, data),

  // RSVP to event
  rsvp: (data) => apiClient.post('/rsvp', data),

  // Delete event
  deleteEvent: (id) => apiClient.delete(`/events/${id}`),

  // Get eCard resend price
  getEcardResendPrice: () => apiClient.get('/ecard-resend-price'),

  // Contact endpoint
  contact: (data) => apiClient.post('/contact', data),

  // Export functions (previously print functions)
  exportPledges: (type = 'pdf') => apiClient.get(`/export/pledges/${type}`, { responseType: 'blob' }),
  exportBudget: (type = 'pdf') => apiClient.get(`/export/budget/${type}`, { responseType: 'blob' }),
  exportFunds: (type = 'pdf') => apiClient.get(`/export/funds/${type}`, { responseType: 'blob' }),
  exportInvitations: (type = 'pdf') => apiClient.get(`/export/invitations/${type}`, { responseType: 'blob' }),
  exportExpenditures: (type = 'pdf') => apiClient.get(`/export/expenditures/${type}`, { responseType: 'blob' }),
};

export default eventApi;